// extracted by mini-css-extract-plugin
export default {"container":"container-__oSj6d4PWY_wgJaiSZM","title":"title-wHUkYdopfpLrUSnOi3Dp"};